import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router'

export class CustomUrlSerializer implements UrlSerializer {
  protected serializer = new DefaultUrlSerializer()

  parse (url: string): UrlTree {
    return this.serializer.parse(url)
  }

  serialize (tree: UrlTree): string {
    return this.serializer.serialize(tree)
      // remove trailing slashes from url
      .replace(/\/$/, '')
  }
}
